export const ERROR_CODES = {
    EXISTS: 'The value already exists',
    MISSING: 'Missing value',
};
